var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvailableBed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98438 5.23445V6.33281H12.2061V5.23445C12.2061 5.18708 12.1676 5.14893 12.1206 5.14893H9.0699C9.02253 5.14893 8.98438 5.18741 8.98438 5.23445Z",
    fill: "#00A79D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2061 9.14536V7.18811H8.98438V9.14536C8.98438 9.19273 9.02286 9.23088 9.0699 9.23088H12.1206C12.1679 9.23088 12.2061 9.1924 12.2061 9.14536Z",
    fill: "#00A79D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5111 10.0862H9.6792V10.7859H11.5111V10.0862Z",
    fill: "#00A79D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.65238 2.82398C2.65304 2.30407 3.0743 1.88281 3.59388 1.88249H9.20373C9.72364 1.88314 10.1449 2.3044 10.1452 2.82398V4.70731H11.0012V2.82398C11.0002 1.83151 10.1959 1.02748 9.20373 1.02649H3.59388C2.60141 1.02748 1.79737 1.83184 1.79639 2.82398V25.7235H2.65238V2.82398Z",
    fill: "#00A79D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.51074 26.1602V27.9577C1.5114 28.4776 1.93266 28.8988 2.45224 28.8991H37.8056C38.3255 28.8985 38.7467 28.4772 38.7471 27.9577V26.1602H1.51074Z",
    fill: "#00A79D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.125 36.9485C33.2736 36.9485 32.5835 37.6386 32.5835 38.4896C32.5835 39.3406 33.2736 40.0307 34.125 40.0307C34.9763 40.0307 35.6661 39.3406 35.6661 38.4896C35.6654 37.6386 34.9756 36.9491 34.125 36.9485Z",
    fill: "#00A79D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7637 29.7554H13.4956V33.0084H26.7637V29.7554Z",
    fill: "#00A79D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.13341 36.9485C5.28209 36.9485 4.59229 37.6386 4.59229 38.4896C4.59229 39.3406 5.28242 40.0307 6.13341 40.0307C6.9844 40.0307 7.67454 39.3406 7.67454 38.4896C7.67388 37.6386 6.98407 36.9491 6.13341 36.9485Z",
    fill: "#00A79D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56104 34.806V35.9188H33.6967V34.806C33.6961 34.2861 33.2748 33.8652 32.7552 33.8645H7.50253C6.98262 33.8652 6.56169 34.2864 6.56104 34.806Z",
    fill: "#00A79D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableBed);
export default __webpack_public_path__ + "static/media/AvailableBed.efa6370ffd0c3f1732559bd8984abba2.svg";
export { ForwardRef as ReactComponent };